import {LOGOUT_LINK} from './constants';

export function delay(ms) {
  /* eslint-disable no-promise-executor-return */
  return new Promise((_) => setTimeout(_, ms));
}

export function isEmpty(obj = {}) {
  return (
    [Object, Array].includes((obj || {}).constructor) &&
    !Object.entries(obj || {}).length
  );
}
export function isUndefined(value) {
  return typeof value === 'undefined';
}

export const handleLogout = async () => {
  try {
    window.location.href = LOGOUT_LINK;
  } catch (error) {
    console.error('Error during logout:', error);
  }
};
